import { Component } from '@angular/core';

import { fuseAnimations } from '@fuse/animations';

///IDIOMAS
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
    selector   : 'gestUsu',
    templateUrl: './gestUsu.component.html',
    styleUrls  : ['./gestUsu.component.scss'],
    animations : fuseAnimations
})
export class GestUsuComponent
{
    funciones: any[]= [
        {
            'id'      : '1',
            'title'   : 'Company profile',
            'slug'    : 'company',
            'category': 'CGO',
            'length'  : 30,
            'icon' : 'domain'
        },
        {
            'id'      : '2',
            'title'   : 'User profile',
            'slug'    : 'user',
            'category': 'CGO',
            'length'  : 30,
            'icon' : 'person'
        }
    ];

    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService
    )
    {


        lang_perfiles.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });
    }
}
